import TokenService from "./token.service.js";

export default {
  isAuthenticated() {
    return (
      localStorage.getItem("user") !== null && TokenService.isAuthenticated()
    );
  },
  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  },
  getUserId() {
    let user = this.getUser();
    return user === null ? NaN : user.id;
  },
  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  },
  logOut() {
    localStorage.removeItem("user");
    TokenService.removeTokens();
  }
};
